import React, { ReactElement } from 'react';
import { Tab } from '@headlessui/react';
import { motion } from 'framer-motion';

import Text from '@components/ui/text';
import Grid from '@components/grid';
import LogoTabLink from '@components/logo-tab-link';
import Container from '@components/ui/container';

// TODO types

export default function LightTabbedFeatures(block: any): ReactElement {
  const { tabs } = block;

  return (
    <Container>
      <Grid>
        <Tab.Group vertical>
          <Tab.List className="col-span-full lg:col-span-6">
            {tabs.map((option: any, idx: number) => {
              return (
                <LogoTabLink
                  key={`solutions-menu-item-${option.id}`}
                  option={option.title}
                  index={idx}
                  onClickTab={() => {
                    document
                      .getElementById('panels')!
                      .scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }}
                  invert={true}
                />
              );
            })}
          </Tab.List>

          <Tab.Panels className="col-span-full lg:col-span-6 bg-accent-1 p-8 md:p-12 lg:p-20">
            <div id={'panels'} />
            {tabs.map((option: any, idx: number) => (
              <Tab.Panel
                key={idx}
                className="flex flex-col justify-start items-start"
              >
                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                >
                  <div className="flex flex-col justify-start items-start">
                    <span className="text-muted-gray text-xs font-light mb-2 uppercase">
                      0{idx + 1}/
                    </span>
                    <Text variant="heading" className="mb-2">
                      {option.title}
                    </Text>
                    <div className="h-[1px] bg-black w-full mb-4" />
                    <Text variant="body" className="text-black">
                      {option.description}
                    </Text>
                  </div>
                </motion.div>
              </Tab.Panel>
            ))}
          </Tab.Panels>
        </Tab.Group>
      </Grid>
    </Container>
  );
}
